import * as React from 'react';
export const cancelSvg = React.forwardRef(function cancelSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.249 1.249a.85.85 0 0 1 1.202 0L6 4.798l3.549-3.549a.85.85 0 1 1 1.202 1.202L7.202 6l3.549 3.549a.85.85 0 1 1-1.202 1.202L6 7.202l-3.549 3.549a.85.85 0 1 1-1.202-1.202L4.798 6l-3.55-3.549a.85.85 0 0 1 0-1.202Z',
    }),
  );
});
cancelSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cancel = {
  category: 'icon',
  colorable: true,
  name: 'cancel',
  svg: cancelSvg,
};
